import { IfcModelInterface } from '../interfaces/ifc-model.interface';

export class IfcModel {
  /**
   * Id.
   */
  public id: number;

  /**
   * Name.
   */
  public name: string;

  /**
   * Status.
   */
  public status: string;

  /**
   * Preview file.
   */
  public previewFile: string;

  /**
   *
   * @param data Data.
   */
  constructor(data: IfcModelInterface) {
    this.id = data.id;
    this.name = data.name;
    this.status = data.status;
    this.previewFile = data.preview_file;
  }
}
